<template>
  <div class="home">
    <Navbar />
    <vue-headful title="USED CODE" />
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";

export default {
  name: "Home",
  components: {
    Navbar,
  },
};
</script>